import type { PhilosophyRepository } from '../../../application/ports/PhilosophyRepository';
import type { PhilosophyEntry } from '../../../domain/philosophy/PhilosophyEntry';
import type { PhilosophyEntryId } from '../../../domain/shared/ids';
import type { AscendInvictusDatabase } from '../AscendInvictusDatabase';
import { PhilosophyEntryMapper } from '../mappers';
import { executePersistence } from '../translatePersistenceError';

export class DexiePhilosophyRepository implements PhilosophyRepository {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public save(entry: PhilosophyEntry): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.philosophyEntries.put(PhilosophyEntryMapper.toRecord(entry));
    });
  }

  public findById(id: PhilosophyEntryId): Promise<PhilosophyEntry | null> {
    return executePersistence('read', async () => {
      const record = await this.database.philosophyEntries.get(id);
      return record ? PhilosophyEntryMapper.fromRecord(record) : null;
    });
  }

  public list(): Promise<readonly PhilosophyEntry[]> {
    return executePersistence('read', async () =>
      (await this.database.philosophyEntries.toArray()).map((record) =>
        PhilosophyEntryMapper.fromRecord(record),
      ),
    );
  }

  public delete(id: PhilosophyEntryId): Promise<void> {
    return executePersistence('write', async () => {
      await this.database.philosophyEntries.delete(id);
    });
  }
}
